<app-lms-modal-frame [title]="'Quote Notes'" [pageHeadWidth]="500">
  <div modal-body>
    <div class="card m-1">
      <div class="card-body p-2">

        <form [formGroup]="quoteNoteForm">
          <div fxFlex class="note-capture-holder">
            <div style="max-height: 300px">
              <table class="container-fluid input-container px-1 d-flex align-content-end justify-content-end">
                <tbody>
                  <td>
                    <input formControlName="noteStr" placeholder="Quote note" required>
                  </td>
                  <td>
                    <button [disabled]="savingNote" class="btn btn-primary btn-rounded mx-1" mdbRipple
                      (click)="addquoteNote()">
                      Add Note</button>
                  </td>
                </tbody>
              </table>
            </div>
            <div fxLayout="row" class="ms-auto my-1 p-md-2 p-lg-3 p-1" fxLayoutAlign="start start" fxLayoutGap="10px">
              <table class="clientnote-list-wrapping table table-striped  table-hover table-sm caption-top">
                <thead>
                  <tr>
                    <th *ngFor="let column of table_config.columns" [hidden]="column.hideCol">{{column.heading}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let table_row of existingNotes; let i = index">
                    <td *ngFor="let column of table_config.columns" [hidden]="column.hideCol">
                      <ng-container *ngIf="column.key === 'createdBy'">
                        <span class="text-emphasis text-start">
                          <div class="font-weight-bold"></div>{{table_row[column.key]}}
                        </span><br>
                        <span class="ms-auto text-emphasis text-end">
                          <small class="ms-auto text-muted text-end">
                            {{table_row['createdOn'] | date: 'yyyy-MM-dd HH:mm:ss'}}
                          </small>
                        </span>
                      </ng-container>
                      <ng-container *ngIf="column.key === 'noteStr'">
                        <div class="d-flex thisnote text-center note note-info">
                          <span class="list-note-item">
                            <div class="font-weight-bold">Note: </div>
                            {{table_row[column.key]}}
                          </span>
                        </div>
                      </ng-container>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div modal-actions class="flex-container">
    <button type="button" class="btn btn-primary btn-sm" (click)="dialogRef.close()">Close</button>
  </div>
</app-lms-modal-frame>
